// @ts-nocheck
import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { css } from "styled-components";

export const getLoadingOverlayProps = (size = 40, minHeight?: string) => {
    const _minHeight = minHeight === undefined ? `${size}px` : minHeight;
    const _halfSize = size / 2;

    return {
        css: css`
            display: block;
            ${_minHeight ? `min-height: ${_minHeight};` : null}
        `,
        spinnerProps: {
            size,
            css: css`
                margin-top: -${_halfSize}px;
                margin-left: -${_halfSize}px;
            `,
        },
    } as LoadingOverlayProps;
};
